import React, { Component, Fragment } from 'react';
import { InputField } from 'Common/SemanticWrapper';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { ControlInfoEnum as Fields } from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';
import { VerificationTypes as types } from '../components/VerificationTypes';

export default class VerificationType extends Component {
  static propTypes = {
    type: PropTypes.oneOf([...Object.values(types), '']).isRequired,
  };

  renderStandard() {
    return (
      <Fragment>
        <Field
          fluid
          component={InputField}
          fieldLabel={'%'}
          label={'All Applications'}
          labelPosition={'right'}
          mode={InputMode.Decimal}
          name={Fields.ErrorProneApplicationPercentage}
          type={'text'}
          disabled={this.props.disabled}
          numericSize={[5, 2]}
        />
        <Field
          fluid
          component={InputField}
          fieldLabel={'$'}
          label={'Error Prone Limit'}
          labelPosition={'left'}
          mode={InputMode.Integer}
          name={Fields.ErrorProneLimit}
          type={'text'}
          disabled={this.props.disabled}
          maxLength={6}
        />
      </Fragment>
    );
  }

  renderRandomAlt1() {
    return (
      <Field
        fluid
        component={InputField}
        fieldLabel={'%'}
        label={'All Applications'}
        labelPosition={'right'}
        mode={InputMode.Decimal}
        name={Fields.RandomApplicationPercentage}
        type={'text'}
        disabled={this.props.disabled}
        numericSize={[5, 2]}
      />
    );
  }

  renderAlt2() {
    return (
      <Fragment>
        <Field
          fluid
          component={InputField}
          fieldLabel={'%'}
          label={'All Applications'}
          labelPosition={'right'}
          mode={InputMode.Decimal}
          name={Fields.Alt2ApplicationPercentage}
          type={'text'}
          disabled={this.props.disabled}
          numericSize={[5, 2]}
        />
        <Field
          fluid
          component={InputField}
          fieldLabel={'$'}
          label={'Error Prone Limit'}
          labelPosition={'left'}
          maxLength={6}
          mode={InputMode.Integer}
          name={Fields.Alt2Limit}
          type={'text'}
          disabled={this.props.disabled}
        />
        <Field
          fluid
          component={InputField}
          fieldLabel={'%'}
          label={'Case Number'}
          labelPosition={'right'}
          mode={InputMode.Decimal}
          name={Fields.Alt2CaseNumberPercentage}
          numericSize={[5, 2]}
          type={'text'}
          disabled={this.props.disabled}
        />
      </Fragment>
    );
  }

  render() {
    const { type } = this.props;

    switch (type) {
      case types.standard:
        return this.renderStandard();

      case types.alternate1:
        return this.renderRandomAlt1();

      case types.alternate2:
        return this.renderAlt2();

      default:
        return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/verificationconfiguration/components/VerificationType.js